import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { MethodSection } from './components/MethodSection';
import { OfferDetails } from './components/OfferDetails';
import { HowItWorks } from './components/HowItWorks';
import { SocialProof } from './components/SocialProof';
import { PricingCTA } from './components/PricingCTA';
const META_PIXEL_ID = '25814268694867293';
function initFacebookPixel() {
  if ((window as any).fbq) return;
  const f = window as any;
  const n: any = f.fbq = function (...args: unknown[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [] as unknown[][];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  f.fbq('init', META_PIXEL_ID);
  f.fbq('track', 'PageView');
}
export function App() {
  useEffect(() => {
    document.title = 'Repostería Casera de Guerra | Emprende desde tu Cocina';
    initFacebookPixel();
  }, []);
  return <main className="min-h-screen w-full bg-cream selection:bg-amber/30 selection:text-chocolate-dark" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <MethodSection data-id="element-3" />
      <OfferDetails data-id="element-4" />
      <HowItWorks data-id="element-5" />
      <SocialProof data-id="element-6" />
      <PricingCTA data-id="element-7" />
      <footer className="py-8 px-6 text-center text-sm" style={{
      backgroundColor: '#3C1518',
      color: '#FFF8F0'
    }} data-id="element-8">
        <p data-id="element-9">
          © {new Date().getFullYear()} Repostería de Guerra. Todos los derechos
          reservados.
        </p>
      </footer>
    </main>;
}